
const calculateMeanInitialRouteDirection = (routeLine, minDistance, maxDistance) => {

  const DEFAULT_DIRECTION = 0;
  const points = routeLine.Points.reverse();

  // You need at least two points to calculate directions
  if (points.Count < 2) {
    return DEFAULT_DIRECTION;
  }

  let length = 0;
  let totalCos = 0.0;
  let totalSin = 0.0;

  let index = 0;
  let startPoint = points[index];

  while(index < points.length && length < maxDistance) {
    index++;
    if(typeof points[index] != 'undefined'){
      const routePoint = points[index];
      const dX = routePoint.x - startPoint.x;
      const dY = routePoint.y - startPoint.y;
      length = Math.sqrt(Math.pow(dX, 2) + Math.pow(dY, 2));

      if (length == 0 || length < minDistance) {
        continue;
      }

      const angleInRadian = Math.atan2(dY, dX);
      totalCos += Math.cos(angleInRadian);
      totalSin += Math.sin(angleInRadian);
    }
  }

  const meanAngle = Math.atan2(totalSin, totalCos);
  return meanAngle;
};

module.exports = {
  calculateMeanInitialRouteDirection
};
